import axios from '../index'
///create crn
export default { 
    updateDetail(id, payload) {
        return axios.post('/bloques-crns/'+ id +'/detail', payload)
    },

    create (payload) {
        return axios.post('/bloques-crns/store', payload)
    },

    //update crn
    update (payload) {
        return axios.post('/bloques-crns/update', payload)
    },

    //delete crn /bloques-crns/delete/id
    delete (id, payload = {}) {
        return axios.post('/bloques-crns/delete/'+ id, payload)
    },

    //delete crn /bloques-crns/listado
    listado (institucionId, params) {
        return axios.get('/bloques-crns/list/' + institucionId, {
            params
        })
    }
    
}